import { WidgetProps } from '@templates/Description/components/Widget/Widget.types';
import { Description, DescriptionBlock, MixedContent } from 'types/Description';
import WidgetType from 'types/Widget';
import getUniqueValues from 'utils/getUniqueValues';

export const getDataPayloadByWidgetTypes = (
  description: Description | DescriptionBlock | MixedContent | undefined,
  widgetTypes: WidgetType[]
): WidgetProps[] =>
  getUniqueValues(
    (description as DescriptionBlock)?.content?.flatMap((block: DescriptionBlock | MixedContent) =>
      [
        block.type === 'mentionAtom' && widgetTypes.includes(block.attrs.id)
          ? JSON.parse(block.attrs['data-payload'])
          : undefined,
        ...((block as DescriptionBlock).content ? getDataPayloadByWidgetTypes(block, widgetTypes) : []),
      ].filter(Boolean)
    ) || [],
    'itemId'
  );

export const getIdsByWidgetTypes = (
  description: Description | DescriptionBlock | MixedContent | undefined,
  widgetTypes: WidgetType[]
): number[] => getDataPayloadByWidgetTypes(description, widgetTypes).map((payload) => payload.itemId) as number[];

export const getDescriptionVideosIds = (
  description: Description | DescriptionBlock | MixedContent | undefined
): number[] => getIdsByWidgetTypes(description, ['ARTICLE_VIDEO']);
